import React from 'react';
// adjust path if you keep it elsewhere

const ApplicationsPage = () => {
  return (
    <div>
      Applications
    </div>
  );
};

export default ApplicationsPage;
